var aspendental = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return theme.typography['buttonLarge'];
    },
    // primary
    containedSizeLarge: {
      height: '64px',
      borderRadius: '32px',
      padding: '22px 28px'
    },
    containedSizeSmall: {
      borderRadius: '26px',
      padding: '16px 24px',
      height: '52px'
    },
    contained: function contained(_ref2) {
      var ownerState = _ref2.ownerState,
          theme = _ref2.theme;

      if (ownerState.name === 'Primary Default') {
        return {
          color: theme.palette.text.light,
          backgroundColor: theme.palette.secondary.main,
          '&:hover': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.secondary.dark
          },
          '&:active': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.light
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.neutral,
            color: theme.palette.text.disabled
          }
        };
      } else if (ownerState.name === 'Primary High Contrast') {
        return {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.neutrals.white,
          '&:hover': {
            color: theme.palette.text.interactive,
            backgroundColor: theme.palette.secondary.light
          },
          '&:active': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.neutrals.primary
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.neutral,
            color: theme.palette.text.disabled
          }
        };
      } else {
        return {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.accent01.dark,
          '&:hover': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.accent01.main
          },
          '&:active': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.accent01.light
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.neutral,
            color: theme.palette.text.disabled
          }
        };
      }
    },
    // secondary
    outlinedSizeLarge: {
      height: '64px',
      borderRadius: '32px',
      padding: '22px 28px'
    },
    outlinedSizeSmall: {
      height: '52px',
      borderRadius: '26px',
      padding: '16px 28px'
    },
    outlined: function outlined(_ref3) {
      var ownerState = _ref3.ownerState,
          theme = _ref3.theme;

      if (ownerState.name === 'Secondary Default') {
        return {
          color: theme.palette.text.interactive,
          border: "1px solid ".concat(theme.palette.secondary.main),
          '&:hover': {
            color: theme.palette.text.interactive,
            backgroundColor: theme.palette.secondary.light,
            border: "1px solid ".concat(theme.palette.secondary.main)
          },
          '&:active': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.secondary.dark,
            border: "1px solid ".concat(theme.palette.secondary.dark)
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.white,
            color: theme.palette.text.disabled
          }
        };
      }

      return {
        color: theme.palette.text.light,
        border: "1px solid ".concat(theme.palette.neutrals.white),
        '&:hover': {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.secondary.light,
          border: "1px solid ".concat(theme.palette.neutrals.white)
        },
        '&:active': {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.neutrals.primary,
          border: "1px solid ".concat(theme.palette.neutrals.white)
        },
        '&:disabled': {
          backgroundColor: theme.palette.backgrounds.dark,
          color: theme.palette.text.disabled,
          border: "1px solid ".concat(theme.palette.text.disabled)
        }
      };
    },
    // tertiary
    textSizeLarge: {
      height: '64px',
      borderRadius: '32px',
      padding: '18px 8px'
    },
    textSizeSmall: {
      height: '52px',
      borderRadius: '26px',
      padding: '10px 8px'
    },
    text: function text(_ref4) {
      var ownerState = _ref4.ownerState,
          theme = _ref4.theme;

      if (ownerState.name === 'Tertiary Default') {
        return {
          color: theme.palette.text.interactive,
          '&:hover': {
            color: theme.palette.text.interactive,
            backgroundColor: theme.palette.secondary.light
          },
          '&:active': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.secondary.dark
          },
          '&:disabled': {
            color: theme.palette.text.disabled
          }
        };
      }

      return {
        color: theme.palette.text.light,
        '&:hover': {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.secondary.light
        },
        '&:active': {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.neutrals.primary
        },
        '&:disabled': {
          // backgroundColor: theme.palette.backgrounds.dark,
          color: theme.palette.text.disabled
        }
      };
    }
  }
};
var motto = {};
var mottoV2 = {
  styleOverrides: {
    root: function root(_ref5) {
      var theme = _ref5.theme;
      return theme.typography['buttonLarge'];
    },
    // primary
    containedSizeLarge: {
      height: '50px',
      borderRadius: '25px',
      padding: '13px 20px'
    },
    containedSizeSmall: {
      borderRadius: '25px',
      padding: '13px 20px',
      height: '43px'
    },
    contained: function contained(_ref6) {
      var ownerState = _ref6.ownerState,
          theme = _ref6.theme;

      if (ownerState.name === 'Primary Default') {
        return {
          color: theme.palette.text.light,
          backgroundColor: theme.palette.primary.main,
          '&:hover': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.primary.main,
            boxShadow: '0px 3px 3px rgba(11, 35, 65, 0.15)'
          },
          '&:active': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.primary.mainLight
          },
          '&:disabled': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.text.disabled
          }
        };
      } else if (ownerState.name === 'Primary High Contrast') {
        return {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.neutrals.white,
          '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.neutrals.white,
            boxShadow: '0px 3px 3px rgba(11, 35, 65, 0.15)'
          },
          '&:active': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.neutrals.white,
            opacity: 0.8
          },
          '&:disabled': {
            color: theme.palette.text.disabled,
            backgroundColor: theme.palette.neutrals.white,
            opacity: 0.5
          }
        };
      } else {
        return {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.accent01.dark,
          '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.accent01.dark,
            boxShadow: '0px 3px 3px rgba(11, 35, 65, 0.15)'
          },
          '&:active': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.accent01.main
          },
          '&:disabled': {
            color: theme.palette.text.disabled,
            backgroundColor: theme.palette.accent01.light
          }
        };
      }
    },
    // secondary
    outlinedSizeLarge: {
      height: '50px',
      borderRadius: '25px',
      padding: '13px 20px'
    },
    outlinedSizeSmall: {
      height: '43px',
      borderRadius: '25px',
      padding: '13px 20px'
    },
    outlined: function outlined(_ref7) {
      var ownerState = _ref7.ownerState,
          theme = _ref7.theme;

      if (ownerState.name === 'Secondary Default') {
        return {
          color: theme.palette.primary.main,
          border: "2px solid ".concat(theme.palette.primary.main),
          '&:hover': {
            color: theme.palette.primary.main,
            border: "2px solid ".concat(theme.palette.primary.mainLight),
            boxShadow: '0px 3px 3px rgba(11, 35, 65, 0.15)',
            backgroundColor: 'transparent'
          },
          '&:active': {
            color: theme.palette.primary.mainLight,
            border: "2px solid ".concat(theme.palette.primary.mainLight)
          },
          '&:disabled': {
            border: "2px solid ".concat(theme.palette.primary.mainLight),
            color: theme.palette.primary.mainLight
          }
        };
      } else if (ownerState.name === 'Secondary High Contrast') {
        return {
          color: theme.palette.neutrals.white,
          border: "2px solid ".concat(theme.palette.neutrals.white),
          '&:hover': {
            color: theme.palette.neutrals.white,
            border: "2px solid ".concat(theme.palette.neutrals.white),
            boxShadow: '0px 3px 3px rgba(11, 35, 65, 0.15)',
            backgroundColor: 'transparent'
          },
          '&:active': {
            color: theme.palette.neutrals.white,
            border: "2px solid ".concat(theme.palette.neutrals.white)
          },
          '&:disabled': {
            color: theme.palette.neutrals.white,
            border: "2px solid ".concat(theme.palette.neutrals.white)
          }
        };
      } else {
        return {
          color: theme.palette.accent01.dark,
          border: "1px solid ".concat(theme.palette.accent01.dark),
          '&:hover': {
            color: theme.palette.accent01.dark,
            border: "1px solid ".concat(theme.palette.accent01.dark),
            boxShadow: '0px 3px 3px rgba(11, 35, 65, 0.15)',
            backgroundColor: 'transparent'
          },
          '&:active': {
            color: theme.palette.accent01.main,
            border: "1px solid ".concat(theme.palette.accent01.main)
          },
          '&:disabled': {
            color: theme.palette.accent01.main,
            border: "1px solid ".concat(theme.palette.accent01.main)
          }
        };
      }
    },
    text: function text(_ref8) {
      var ownerState = _ref8.ownerState,
          theme = _ref8.theme;

      if (ownerState.name === 'Arrow Default') {
        return {
          color: theme.palette.primary.main,
          '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: 'transparent'
          },
          '&:active': {
            color: theme.palette.primary.main,
            backgroundColor: 'transparent'
          },
          '&:disabled': {
            color: theme.palette.text.disabled,
            backgroundColor: 'transparent'
          }
        };
      } else if (ownerState.name === 'Arrow High Contrast') {
        return {
          color: theme.palette.neutrals.white,
          '&:hover': {
            color: theme.palette.neutrals.white,
            backgroundColor: 'transparent'
          },
          '&:active': {
            color: theme.palette.neutrals.white,
            backgroundColor: 'transparent'
          },
          '&:disabled': {
            color: theme.palette.neutrals.white,
            backgroundColor: 'transparent'
          }
        };
      }
    }
  }
};
var wellnow = {
  styleOverrides: {
    root: function root(_ref9) {
      var theme = _ref9.theme;
      return theme.typography['button'];
    },
    // primary
    containedSizeLarge: {
      height: '64px',
      borderRadius: '8px',
      padding: '22px 28px'
    },
    containedSizeSmall: {
      borderRadius: '8px',
      padding: '16px 24px',
      height: '52px'
    },
    contained: function contained(_ref10) {
      var ownerState = _ref10.ownerState,
          theme = _ref10.theme;

      if (ownerState.name === 'Primary Default') {
        return {
          color: theme.palette.text.light,
          backgroundColor: theme.palette.secondary.main,
          '&:hover': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.secondary.dark
          },
          '&:active': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.light
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.neutral,
            color: theme.palette.text.disabled
          }
        };
      } else if (ownerState.name === 'Primary High Contrast') {
        return {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.neutrals.white,
          '&:hover': {
            color: theme.palette.text.interactive,
            backgroundColor: theme.palette.secondary.light
          },
          '&:active': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.light
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.neutral,
            color: theme.palette.text.disabled
          }
        };
      } else {
        return {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.tertiary.dark,
          '&:hover': {
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.tertiary.main
          },
          '&:active': {
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.tertiary.light
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.neutral,
            color: theme.palette.text.disabled
          }
        };
      }
    },
    // secondary
    outlinedSizeLarge: {
      height: '64px',
      borderRadius: '8px',
      padding: '22px 28px'
    },
    outlinedSizeSmall: {
      height: '52px',
      borderRadius: '8px',
      padding: '16px 28px'
    },
    outlined: function outlined(_ref11) {
      var ownerState = _ref11.ownerState,
          theme = _ref11.theme;

      if (ownerState.name === 'Secondary Default') {
        return {
          color: theme.palette.text.interactive,
          border: "1px solid ".concat(theme.palette.secondary.main),
          '&:hover': {
            color: theme.palette.text.interactive,
            backgroundColor: theme.palette.secondary.light,
            border: "1px solid ".concat(theme.palette.secondary.main)
          },
          '&:active': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.secondary.dark,
            border: "1px solid ".concat(theme.palette.secondary.dark)
          },
          '&:disabled': {
            backgroundColor: theme.palette.neutrals.white,
            color: theme.palette.text.disabled,
            border: "1px solid ".concat(theme.palette.text.disabled)
          }
        };
      }

      return {
        color: theme.palette.text.light,
        border: "1px solid ".concat(theme.palette.neutrals.white),
        '&:hover': {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.primary.light,
          border: "1px solid ".concat(theme.palette.secondary.light)
        },
        '&:active': {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.neutrals.primary,
          border: "1px solid ".concat(theme.palette.neutrals.white)
        },
        '&:disabled': {
          // backgroundColor: theme.palette.backgrounds.dark,
          color: theme.palette.text.disabled,
          border: "1px solid ".concat(theme.palette.text.disabled)
        }
      };
    },
    // tertiary
    textSizeLarge: {
      height: '64px',
      borderRadius: '8px',
      padding: '18px 8px'
    },
    textSizeSmall: {
      height: '52px',
      borderRadius: '8px',
      padding: '10px 8px'
    },
    text: function text(_ref12) {
      var ownerState = _ref12.ownerState,
          theme = _ref12.theme;

      if (ownerState.name === 'Tertiary Default') {
        return {
          color: theme.palette.text.interactive,
          '&:hover': {
            color: theme.palette.text.interactive,
            backgroundColor: theme.palette.secondary.light
          },
          '&:active': {
            color: theme.palette.text.light,
            backgroundColor: theme.palette.secondary.dark
          },
          '&:disabled': {
            color: theme.palette.text.disabled
          }
        };
      }

      return {
        color: theme.palette.text.light,
        '&:hover': {
          color: theme.palette.text.interactive,
          backgroundColor: theme.palette.secondary.light
        },
        '&:active': {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.neutrals.primary
        },
        '&:disabled': {
          color: theme.palette.text.disabled
        }
      };
    }
  }
};
export { wellnow, aspendental, motto, mottoV2 };